import {
  Card,
  Divider,
  Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Api from '../../services/api';
import { getFormModAndID } from '../smart-kit/Form/gridFormUtils';
import { translate } from 'translate';
import * as momentj from 'moment-jalaali';

const DataView = ({ apipath, columns, extraCard: ExtraCard }) => {
  const { uuid } = getFormModAndID();

  const [tabValue, setTabValue] = useState(0);
  const [entity, setEntity] = useState();

  useEffect(() => {
    (async () => {
      const data = await Api.get(`${apipath}/${uuid}`);
      setEntity(data);
    })();
  }, []);

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
  };

  const renderViewDataRow = (col, entity) => {
    return (
      <ViewDataRow label={translate(col.label)}>
        {col.render ? (
          col.render(entity)
        ) : Array.isArray(entity[col.key]) ? (
          entity[col.key].join(', ')
        ) : col.type === 'date' && entity[col.key] ? (
          <div className="ltr">{momentj(entity[col.key]).format('jYYYY-jMM-jDD HH:mm')}</div>
        ) : col.type === 'picture' ? (
          <a href={Api.getPhotoUrl(entity[col.key])} target="_blank">
            <img width={400} src={Api.getPhotoUrl(entity[col.key])} />
          </a>
        ) : (
          entity[col.key]
        )}
      </ViewDataRow>
    );
  };

  if (entity)
    return (
      <div className="">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Details" />
        </Tabs>
        <Divider className="mb-6" />

        {tabValue === 0 && (
          <Grid container spacing={3} className="pr-2">
            <ViewCard title={translate(entity.name)}>
              {columns.map((col, i) => {
                if (col.label) {
                  return renderViewDataRow(col, entity);
                }
              })}
            </ViewCard>
            {ExtraCard && (
              <ViewCard>
                <ExtraCard />
              </ViewCard>
            )}
          </Grid>
        )}
      </div>
    );
  else return <></>;
};

export default DataView;

const ViewCard = ({ title, children }) => {
  return (
    <Grid item xs={12} md={6} lg={8}>
      <Card elevation={3} className="pt-6">
        <div className="flex-column items-center mb-6">
          <h4>{title}</h4>
        </div>
        <Divider />
        <Table className="mb-4">
          <TableBody>{children}</TableBody>
        </Table>
      </Card>
    </Grid>
  );
};

export const ViewDataRow = ({ label, children }) => {
  return (
    <TableRow>
      <TableCell className="pr-4">{label}</TableCell>
      <TableCell>{children}</TableCell>
    </TableRow>
  );
};
